import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const InsightSummaryRoot = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 12px;
  ${borderRadius.r2};
  border: 1px solid var(--border-soft);
  background-color: var(--surface-default);
`;

export const InsightCardWrapper = styled.div`
  ${borderRadius.r2};
  padding: 12px 16px;
  border: 1px solid var(--border-soft);
  width: 100%;
`;

export const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const Title = styled.div`
  color: var(--text-default);
  ${typographyV2.titleBase};
`;

export const FooterText = styled.div`
  ${typographyV2.bodySm};
  color: var(--text-default);
`;
